import React from 'react';
import _ from 'lodash';

export default ({ post }) => {
    let state = _.get(post, ['status', 'state']);
    let step = _.get(post, ['status', 'step']);
    let attempts = _.get(post, ['status', 'attempts']);
    if (state === 'failed' && step === 'awaiting_for_moderation' && attempts === 1) state = 'Rejected';

    return (
        <span>
            {state} {step}
        </span>
    );
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/containers/Posts/PostStatus.js
 **/